import React from 'react';
import { SpinnerTW } from '../spinnerTW/SpinnerTW';
import { SpinnerSize } from '../../ui-toolkit';

export const LoadingSpinnerTW: React.FC<{
  children: React.ReactNode;
  isLoading?: boolean;
  spinnerSize?: SpinnerSize;
}> = ({ children, isLoading, spinnerSize }) => {
  if (isLoading) {
    return <SpinnerTW size={spinnerSize ?? SpinnerSize.regular} />;
  }
  return <>{children}</>;
};
